@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Eieform tomt</h2>

    <div class="expander siteTypes" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <div class="left">
                <ul>
                    @for (siteType of this.filterForm().siteTypes; track $index) {
                        <li class="check-box" data-cy="checkbox-click" (click)="toggleSelectedSiteType(siteType().value())">
                            <input
                                type="checkbox"
                                class="checkbox-icon"
                                [formField]="siteType.selected"
                                [class.selected]="siteType.selected().value()"
                            />
                            <label> {{ siteType.displayText().value() }} </label>
                        </li>
                    }
                </ul>
            </div>
            <div class="right">
                <div class="select-all-btn" data-cy="click-all" (click)="selectAllSiteTypes()">
                    <label>Alle</label>
                </div>
            </div>
        </div>
    </div>
}
